import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import { QRGeneratorPage } from './pages/QRGeneratorPage';
import { DashboardPage } from './pages/DashboardPage';
import { WiFiQRPage } from './pages/WiFiQRPage';
import { VCardQRPage } from './pages/VCardQRPage';
import { SMSQRPage } from './pages/SMSQRPage';
import { EmailQRPage } from './pages/EmailQRPage';
import { GoogleAnalytics } from './components/analytics/GoogleAnalytics';
import { DynamicQRPage } from './pages/DynamicQRPage';
import { DynamicQRGeneratorPage } from './pages/DynamicQRGeneratorPage';
import { DynamicQRAnalyticsPage } from './pages/DynamicQRAnalyticsPage';
import { AccountPage } from './pages/AccountPage';
import { TemplatesPage } from './pages/TemplatesPage';
// import { EnvStatus } from './components/debug/EnvStatus';
import './App.css';

function App() {
  return (
    <Router>
      <GoogleAnalytics />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        <Header />
        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<QRGeneratorPage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/wifi-qr-code-generator" element={<WiFiQRPage />} />
            <Route path="/vcard-qr-code-generator" element={<VCardQRPage />} />
            <Route path="/sms-qr-code-generator" element={<SMSQRPage />} />
            <Route path="/email-qr-code-generator" element={<EmailQRPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/dynamic" element={<DynamicQRPage />} />
              <Route path="/dynamic/create" element={<DynamicQRGeneratorPage />} />
              <Route path="/dynamic/:shortCode/analytics" element={<DynamicQRAnalyticsPage />} />
              <Route path="/templates" element={<TemplatesPage />} />
            </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
